/* ABB cart v2 (preview 4 Nov 2026). Replaces abb-gift-fix3.js + abb-code-gift-guard.js.
   Single $90 gift (shopper picks ONE), combinable with discount codes, threshold counted BEFORE discounts (pre-discount items subtotal).
   - no window.confirm / alert, no per-item tag lookups, no page reloads, express buttons never disabled
   - checkout click: one /cart.js read (+ at most one /cart/update.js), spinner, then /checkout */
(function () {
  if (window.__abbCartV2) return; window.__abbCartV2 = true;
  var GIFT_CARD_PRODUCTS = [0xe03f6bd0053];
  function threshold() { var t = window.cartGiftTiers || {}; return Number(t[1]) || 9000; }
  function isGift(i) { var p = (i && i.properties) || {}; return String(p._gift) === 'true' || String(p.__upez_free_gift) === 'true'; }
  function isGiftCard(i) { return !!i && (i.gift_card === true || GIFT_CARD_PRODUCTS.indexOf(Number(i.product_id)) > -1); }
  // 5 Nov 2026 (Stephen): threshold counted BEFORE coupon/line discounts; gift lines and gift cards excluded.
  function eligibleAfterDiscount(cart) {
    return (cart.items || []).reduce(function (s, i) { return isGift(i) || isGiftCard(i) ? s : s + (Number(i.original_line_price) || 0); }, 0);
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  // Allowed: one gift line, qty 1, only when eligible total >= $90. Everything else (legacy tier-2/3 gifts, extra qty) is removed.
  function planUpdates(cart) {
    var gifts = (cart.items || []).filter(isGift), ok = eligibleAfterDiscount(cart) >= threshold(), updates = {}, kept = false;
    gifts.forEach(function (g) {
      // 5 Nov: Shopify won't stack the Tier 1 BXGY with product-class codes (e.g. WELCOME10), so a gift line that
      // isn't $0 would be charged. Never let a shopper pay for a "free" gift: drop priced gift lines.
      var priced = Number(g.final_line_price) > 0;
      if (ok && !kept && !priced) { kept = true; if (g.quantity > 1) updates[g.key] = 1; }
      else updates[g.key] = 0;
    });
    return Object.keys(updates).length ? updates : null;
  }
  function applyUpdates(updates) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
  }
  function rerenderInPlace() {
    var d = document.querySelector('cart-drawer');
    try {
      if (d && d.fetchCartDrawerSections && d.renderContents) {
        d.fetchCartDrawerSections().then(function (s) { if (s) d.renderContents(s); }).catch(function () {});
      }
      var ci = document.querySelector('cart-items');
      if (ci && typeof ci.onCartUpdate === 'function') ci.onCartUpdate();
    } catch (e) { console.warn('abb cart v2 rerender', e); }
  }
  var busy = null;
  function enforce() {
    if (busy) return busy;
    busy = getCart().then(function (cart) {
      var u = planUpdates(cart); if (!u) return false;
      return applyUpdates(u).then(function () { rerenderInPlace(); return true; });
    }).catch(function (e) { console.warn('abb cart v2', e); return false; }).finally(function () { busy = null; });
    return busy;
  }
  window.abbGiftEnforce = enforce;

  // Checkout: instant feedback, single check, hard 2.5s fallback so the button can never hang.
  var SEL = '#CartDrawer-Checkout, button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]', going = false;
  function go(ev, el) {
    if (going) { ev.preventDefault(); return; }
    ev.preventDefault(); ev.stopImmediatePropagation(); going = true;
    if (el) { el.setAttribute('aria-busy', 'true'); el.classList.add('loading'); if (el.dataset) el.dataset.abbLabel = el.textContent; if (el.tagName !== 'INPUT') el.textContent = 'Going to checkout…'; }
    var done = false; function nav() { if (!done) { done = true; location.href = '/checkout'; } }
    setTimeout(nav, 2500);
    enforce().then(nav, nav);
  }
  window.addEventListener('click', function (ev) { var el = ev.target instanceof Element ? ev.target.closest(SEL) : null; if (el && !el.disabled) go(ev, el); }, true);
  window.addEventListener('submit', function (ev) { var s = ev.submitter; if (s && s.name === 'checkout') go(ev, s); }, true);
  window.addEventListener('pageshow', function () { going = false; });

  // Codes no longer block or strip the $90 gift: neutralise the drawer's promo-blocking + dead checkout handler.
  customElements.whenDefined('cart-drawer').then(function () {
    var C = customElements.get('cart-drawer'); if (!C || C.prototype.__abbV2) return; C.prototype.__abbV2 = true;
    var P = C.prototype;
    P.cartHasCustomerPromo = function () { return false; };
    P.isPromoRemovableGiftLine = function () { return false; };
    if (P.setGiftPromoBlockedUi) { var o = P.setGiftPromoBlockedUi; P.setGiftPromoBlockedUi = function () { return o.call(this, false); }; }
    P.ensureGiftDiscountBeforeCheckout = function () {};
    var open = P.open; if (open) P.open = function () { var r = open.apply(this, arguments); soon(1200); return r; };
    var cg = P.claimGift; if (cg) P.claimGift = async function () { var r = await cg.apply(this, arguments); soon(600); return r; };
  });
  var t = null; function soon(ms) { clearTimeout(t); t = setTimeout(enforce, ms || 1200); }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { soon(1500); });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', function () { soon(1500); }, { once: true }) : soon(1500);
})();
